import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import AppAgt from './AppAgt';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootAgt = ReactDOM.createRoot(document.getElementById('rotAgt'));
rootAgt.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
